// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__undos","h2":"Heading_h2__hu42e","h3":"Heading_h3__ERBqS","h4":"Heading_h4__7Ck1P"};